import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const BackToTopContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['borderTop'].includes(prop),
})<{
  borderTop: boolean;
}>`
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-component-inner-sm) 0;
  border-top: ${({ borderTop }) =>
    borderTop ? '1px solid var(--c-border)' : 'none'};

  ${medias.max.mobile} {
    display: none;
  }
`;
